import { fetchTodaySchedule } from './googleCalendar';

export const loadSchedule = async () => {
    const today = new Date().toLocaleDateString('en-CA');
    const savedSchedule = localStorage.getItem('schedule');
    const savedScheduleDate = localStorage.getItem('scheduleDate');

    if (savedScheduleDate === today && savedSchedule) {
        return JSON.parse(savedSchedule);
    }

    console.log('New day detected, fetching today\'s schedule');

    try {
        const todaySchedule = await fetchTodaySchedule(null);
        if (todaySchedule) {
            localStorage.setItem('schedule', JSON.stringify(todaySchedule));
            localStorage.setItem('scheduleDate', today);
            return todaySchedule;
        }
        return null;
    } catch (error) {
        console.error('Error fetching schedule:', error);
        return null;
    }
};